"use strict";

var _createForOfIteratorHelper = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validate_1 = require("../../compile/validate");

var code_1 = require("../code");

var util_1 = require("../../compile/util");

var additionalProperties_1 = require("./additionalProperties");

var def = {
  keyword: "properties",
  type: "object",
  schemaType: "object",
  code: function code(cxt) {
    var gen = cxt.gen,
        schema = cxt.schema,
        parentSchema = cxt.parentSchema,
        data = cxt.data,
        it = cxt.it;

    if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) {
      additionalProperties_1.default.code(new validate_1.KeywordCxt(it, additionalProperties_1.default, "additionalProperties"));
    }

    var allProps = code_1.allSchemaProperties(schema);

    var _iterator = _createForOfIteratorHelper(allProps),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        it.definedProperties.add(prop);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (it.opts.unevaluated && allProps.length && it.props !== true) {
      it.props = util_1.mergeEvaluated.props(gen, util_1.toHash(allProps), it.props);
    }

    var properties = allProps.filter(function (p) {
      return !util_1.alwaysValidSchema(it, schema[p]);
    });
    if (properties.length === 0) return;
    var valid = gen.name("valid");

    var _iterator2 = _createForOfIteratorHelper(properties),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _prop = _step2.value;

        if (hasDefault(_prop)) {
          applyPropertySchema(_prop);
        } else {
          gen.if(code_1.propertyInData(gen, data, _prop, it.opts.ownProperties));
          applyPropertySchema(_prop);
          if (!it.allErrors) gen.else().var(valid, true);
          gen.endIf();
        }

        cxt.it.definedProperties.add(_prop);
        cxt.ok(valid);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    function hasDefault(prop) {
      return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
    }

    function applyPropertySchema(prop) {
      cxt.subschema({
        keyword: "properties",
        schemaProp: prop,
        dataProp: prop
      }, valid);
    }
  }
};
exports.default = def;